// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoActions_root__Wq1Cf"};